module.exports = __webpack_public_path__ + "img/item.6b5e65f3.png";